import React from 'react'
import CandidateAppliedJobs from './components/AppliedJobsPage'

const AppliedJobs = () => {
  return (
    <div>
      <CandidateAppliedJobs />
    </div>
  )
}

export default AppliedJobs;